import { lang } from '@umu/ukit-lang';
/**
 * @description 时间选择器组件，可以选择年 月 日 时 分
 * @author junchao
 * @date 2021-04-09 14:41
 */
import './timePicker.scss';
import { localeConfig } from 'common/src/services/localeConfig';
import Picker from '@umu/umu-picker';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import dayjsGenerateConfig from '@umu/umu-picker/lib/generate/dayjs';

export interface IProps {
    format?: string;
    picker?: string;
    showNow?: boolean;
    initValue?: string;
    readonly?: boolean;
    className?: string;
    disabledClean?: boolean;
    dateNowTime?: Date; // 加这个属性主要是为了监听initValue 的变化
    disabled?: boolean;
    allowClear?: boolean;
    placeholder?: string;
    isShowNoSetting?: boolean;
    dropdownClassName?: string;
    suffixIcon?: React.ReactNode;
    onChange: (newValue: any) => void;
    disabledDate?: (date: any) => void;
    disabledTime?: (date?: any) => void;
    handlerConfirmSelect?: (value: string) => void;
    getPopupContainer?: (triggerNode?: HTMLElement) => HTMLElement;
}
const FORMAT_TIME_RULE = 'YYYY-MM-DD HH:mm';

const UMUPicker: any = Picker;

export function TimePicker(props: IProps) {
    const initValue = props.initValue === '' ? null : dayjs(props.initValue);
    // value 当前选中的时间
    const [value, setValue] = useState(initValue);
    const [endOpen, setEndOpen] = useState(false);

    useEffect(() => {
        setValue(initValue);
    }, [props.initValue]);

    useEffect(() => {
        if (props.initValue === null) {
            setValue(null);
        }
    }, [props.dateNowTime]);
    useEffect(() => {
        if (props.disabled && props.disabledClean) {
            setValue(null);
        }
    }, [props.disabled]);
    const onSelect = (newValue: any) => {
        if (!props.handlerConfirmSelect) {
            return;
        }
        setValue(newValue);
        props.handlerConfirmSelect(dayjs(newValue.$d).format(FORMAT_TIME_RULE));
    };
    const onChange = (newValue: any) => {
        setValue(newValue);
        if (newValue === null) {
            props.onChange('');
            return;
        }
        props.onChange(
            props.picker === 'time'
                ? dayjs(newValue.$d).format(props.format || FORMAT_TIME_RULE)
                : dayjs(newValue.$d).format(FORMAT_TIME_RULE),
        );
    };

    const sharedProps = {
        generateConfig: dayjsGenerateConfig,
        value,
        onSelect,
        onChange,
    };
    //  设置不可选中日期
    const disabledDate = props.disabledDate;

    // 设置不可选中时间
    const disabledTime = props.disabledTime;

    const renderExtraFooter = () => {
        if (!props.isShowNoSetting) {
            return null;
        }
        return (
            <div
                onClick={() => {
                    props.onChange('');
                    setValue(null);
                    setEndOpen(false);
                }}
            >
                {lang('不设置')}
            </div>
        );
    };

    const defaultSuffixIcon =
        props.picker === 'time' ? <div className="time-select-icon" /> : <div className="time-icon"></div>;
    const suffixIcon = props.suffixIcon || defaultSuffixIcon;

    return (
        <UMUPicker
            {...props}
            {...sharedProps}
            locale={localeConfig.locale}
            defaultPickerValue={value}
            showTime={{
                format: 'HH:mm',
                showSecond: false,
                defaultValue: value,
                hideDisabledOptions: !props.handlerConfirmSelect ? true : false,
            }}
            format={props.format || localeConfig.dateDisplayFormat}
            open={endOpen}
            showToday
            disabledTime={disabledTime}
            disabledDate={disabledDate}
            placeholder={props.placeholder || lang('不设置')}
            inputReadOnly={props.readonly}
            allowClear={props.allowClear}
            clearIcon={<div className="clear-icon"></div>}
            suffixIcon={suffixIcon}
            showNow={props.showNow}
            disabled={props.disabled || false}
            onOpenChange={(open: boolean) => {
                setEndOpen(open);
            }}
            renderExtraFooter={renderExtraFooter}
        />
    );
}
